import { createContext } from 'react'
import { IQuery } from '../helpers'

export type Condition = '$eq'|'$like'|'$in'
export type IPageFilter = [string, string, any] // property, condition, term
export type IPageFilterOptionLookup = { [id: string]: IPageFilterOption }
export interface IPageFilterOption<T = any> {
  id: string
  label: string
  type: 'page'|'attribute'|'header'
  key?: string
  conditions: IPageFilterCondition<any>[]
  prepareTerm?(term: T): any
  addToQuery?(query: IQuery, filter: IPageFilter): IQuery
  renderForm(value: T, setValue: (value: T) => void, condition?: IPageFilterCondition<T>): JSX.Element
}

export interface IPageFilterCondition<T> {
  id: string
  label: string
  default?: T
  renderForm?(value: T, setValue: (value: T) => void): JSX.Element
  addToQuery(query: IQuery, filter: IPageFilterOption<T>, value: T): IQuery
  validateTerm?(term: T): boolean
}

export const PageFilterOptionsContext = createContext<IPageFilterOption[]>([])

export const PAGE_FILTER_DEFAULT = (filter: IPageFilterOption<any>): IPageFilter => [
  filter?.id,
  filter?.conditions[0]?.id,
  filter?.conditions[0]?.default,
]

export const PAGE_FILTERS_TO_QUERY = (filters: IPageFilter[], opts: IPageFilterOption<any>[]): IQuery => {
  let q = { selector: {} }

  filters.forEach((f) => {
    const [property, condition, term] = f
    const filter = opts.find(opt => opt.id === property)
    if (!property || !condition || !filter) { return }
    const cond = filter.conditions.find(c => c.id === condition)

    if (cond?.validateTerm) {
      if (!cond.validateTerm(term)) { return }
    } else if (!term) {
      return
    }

    if (cond) {
      q = cond.addToQuery(q, filter, filter.prepareTerm ? filter.prepareTerm(term) : term)
      if (filter.addToQuery) { q = filter.addToQuery(q, f) }
    }
  })

  return q
}
